export default __webpack_public_path__ + "static/media/USDT.c97d85c7.svg";